const t=[1,2,3,4,5],d={1:75,2:50,3:35,4:23,5:20},e=.08,o=100,r=8192,s={isHydrated:!1};export{t as DEFAULT_DPR,e as DEFAULT_SRCSET_WIDTH_TOLERANCE,d as DPR_QUALITIES,r as MAX_SRCSET_WIDTH,o as MIN_SRCSET_WIDTH,s as hydrationStatus};
//# sourceMappingURL=constants.js.map
